import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tab-slug" }
const _hoisted_2 = { class: "content" }

import ListSlug from "@/components/lists/list-game-slug.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'slug',
  props: {
    ownerId: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ListSlug, {
        "owner-id": __props.ownerId,
        type: null
      }, null, 8, ["owner-id"])
    ])
  ]))
}
}

})